module.exports = __webpack_public_path__ + "img/tuts-rating-background.1e57ce9c.png";